<div
  class="wrapper p-field"
  [style.fontSize]="fontSize"
  [ngClass]="getWrapperNgClasses"
  [formGroup]="controlContainer.control"
>
  <label
    *ngIf="label && !float"
    class="label label__static"
    [for]="controlName"
    >{{ label }}</label
  >

  <hospitality-bot-custom-tooltip
    *ngIf="additionalInfo"
    [text]="additionalInfo"
    class="additional-info"
    mode="standalone"
  ></hospitality-bot-custom-tooltip>
  <input
    [ngClass]="getInputClass"
    [ngStyle]="style"
    [style.padding-left.px]="search ? 40 : null"
    [attr.disabled]="isDisabled || null"
    [formControlName]="!manualInputBinding ? controlName : null"
    [value]="manualInputBinding ? tempValue : control?.value"
    (input)="
      type === 'number' && maxLength
        ? ($any($event.target).value = $any($event.target).value.slice(0, maxLength))
        : null;
      manualInputBinding ? handleManualInputChange($event.target.value) : null
    "
    [id]="controlName"
    [attr.type]="type"
    pInputText
    [minLength]="minLength"
    [maxlength]="maxLength"
    [min]="min"
    [max]="max"
    [placeholder]="placeholder"
    (keydown)="
      handleKeyClick($event);
      type === 'number' && maxLength && $event.key.length === 1 &&
      $any($event.target).value.length >= maxLength
        ? $event.preventDefault()
        : null
    "
    [tabindex]="tabIndex"
    (wheel)="disableValueChangesOnScroll($event)"
    (click)="$event.stopPropagation()"
    (focus)="onFocus.emit($event)"
    (blur)="handleBlur($event)"
    [pAutoFocus]="isFocus"
  />
  <i *ngIf="search" class="pi pi-search search-icon"></i>
  <!-- (wheel)="$event.preventDefault(); $event.stopPropagation()" -->

  <ng-container *ngIf="!isLoading">
    <small *ngIf="prefix" class="prefix"
      ><ng-container *ngIf="!strike; else strikeText">{{
        prefix
      }}</ng-container>
    </small>
    <small *ngIf="subtitle" class="subtitle"
      ><ng-container *ngIf="!strike; else strikeText">{{
        subtitle
      }}</ng-container>
    </small>
    <small *ngIf="viewButton" class="save-cta">
      <a class="input-btn" type="submit" (click)="onSaveText.emit()">
        {{ buttonText }}
      </a>
    </small>
    <small *ngIf="customTemplate" class="subtitle">
      <ng-content *ngTemplateOutlet="customTemplateRef"> </ng-content>
    </small>
    <ng-template #strikeText>
      <del>{{ subtitle }}</del>
    </ng-template>
  </ng-container>

  <small *ngIf="error && isErrorVisible" class="p-error"> {{ error }}</small>

  <label *ngIf="label && float" [for]="controlName" class="label">{{
    label
  }}</label>
  <i
    *ngIf="isLoading"
    class="pi pi-spin pi-spinner"
    [ngClass]="iconNgClass"
  ></i>
</div>

<div [hidden]="true">{{ calculateInputLength() }}</div>
